"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = NoOuterWhitespaceRule;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _criteriaRule = _interopRequireDefault(require("../criteria-rule"));

/**
 * Rule component requiring no spaces at start or end of input.
 *
 * @displayName NoOuterWhitespaceRule
 *
 * @param {Object} props Props
 * @returns {ReactElement} ReactElement
 */
function NoOuterWhitespaceRule(props) {
  return /*#__PURE__*/_react.default.createElement(_criteriaRule.default, (0, _extends2.default)({
    validate: v => v.trim() === v
  }, props), props.children);
}
/**
 * PropType validation.
 *
 * @type {Object}
 * @private
 */


NoOuterWhitespaceRule.propTypes = {
  /** Child elements */
  children: _propTypes.default.node
};